<template>
	<li class="comments__expand">
		<a
			class="button"
			href="#"
			v-if="
				range.hidden 
				&& loadCount 
				&& commentsCount > limit 
				&& index === 0
			"
			@click.prevent.stop="expandComments('old')"
			>
			<i class="icon icon-chevron-down" />
			Load oldest {{ loadCount }}
		</a>

		<a class="button" href="#" @click.prevent.stop="expandComments()">
			<i class="icon icon-chevrons-expand" />
			{{ `Load all ${commentsCount} message${commentsCount === 1 ? '' : 's'}` }}
		</a>

		<a
			class="button"
			href="#"
			v-if="
				range.hidden 
				&& loadCount 
				&& commentsCount > limit
			"
			@click.prevent.stop="expandComments('new')"
			>
			<i class="icon icon-chevron-up" />
			Load {{ loadCount }} messages
		</a>
		
		<loading class="comments__loading" :visible="isLoading" />
	</li>
</template>

<script>
import Loading from '../components/Loading.vue';

export default {
	name: 'comment-expander',

	components: {
		Loading,
	},

	emits: ['comments:expand'],

	props: {
		range: {
			required: true,
			type: Object,
		},

		isExpanding: {
			default: false,
		},

		index: {
			type: Number,
			default: 0,
		},
	},

	data() {
		return {
			state: '',
			hiddenComments: [],
			chunks: 50,
			limit: 150,
		};
	},

	computed: {
		isLoading() {
			return this.state === 'loading' || this.isExpanding;
		},

		commentsCount() {
			return this.range.hidden?.length || this.range.count || 0;
		},

		loadCount() {
			return Math.min(this.chunks, this.commentsCount);
		},
	},

	methods: {
		expandComments(type) {
			if (this.isLoading) return;
			let from = this.range.start;
			let to = this.range.end;
			const count = Math.min(this.chunks, this.commentsCount);

			if (type === 'old' && this.commentsCount) {
				to = this.hiddenComments[Math.min(count - 1, this.commentsCount - 1)] ?? to;
				this.hiddenComments = this.hiddenComments.slice(count);
			} else if (type === 'new' && this.commentsCount) {
				from = this.hiddenComments[Math.max(0, this.commentsCount - count)] ?? from;
				this.hiddenComments = this.hiddenComments.slice(0, Math.max(0, this.commentsCount - count));
			} else {
				this.hiddenComments = [];
			}

			const payload = {
				from,
				to,
			};

			this.state = 'loading';
			this.$emit('comments:expand', {
				payload,
				hidden: this.hiddenComments,
				range: this.range
			});
		},


	},

	mounted() {
		if (this.range.hidden) {
			this.hiddenComments = this.range.hidden;
		}
	},
}
</script>
